export default "__VITE_ASSET__BIm4RbyV__"